<template>
  <div>
    <div>
      <h2>{{ $t("system-defaults.template-management.text") }}</h2>
    </div>

    <div class="bg-white">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <!-- BEGIN TABS-->
              <b-tabs card nav-class="nav-tabs-custom " v-model="activeTab" content-class="mt-1 p-3">
                <!-- BEGIN TAB-->
                <b-tab>
                  <template v-slot:title>
                    <span>
                      {{ $t("system-defaults.template-management.sector-department.text") }}
                    </span>
                  </template>
                  <SectorDepartmentView v-if="activeTab == 0" />
                </b-tab>

                <b-tab>
                  <template v-slot:title>
                    <span>
                      {{ $t("system-defaults.template-management.department-process.text") }}
                    </span>
                  </template>
                  <DepartmentProcessView v-if="activeTab == 1" />
                </b-tab>

                <b-tab>
                  <template v-slot:title>
                    <span>
                      {{ $t("system-defaults.template-management.process-datasource.text") }}
                    </span>
                  </template>
                  <ProcessDatasourceView v-if="activeTab == 2" />
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <span>
                      {{ $t("system-defaults.template-management.datasource-data.text") }}
                    </span>
                  </template>
                  <DatasourceDataView v-if="activeTab == 3" />
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <span>
                      {{ $t("system-defaults.template-management.department-process-datasource-datasubject.text") }}
                    </span>
                  </template>
                  <DepartmentProcessDatasourceView v-if="activeTab == 4" />
                </b-tab>

                <b-tab>
                  <template v-slot:title>
                    <span>
                      Süreç - Veri Kaynağı Saklama Süresi
                    </span>
                  </template>
                  <ProcessDatasourceStoragePeriodView v-if="activeTab == 5" />
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <span>
                      İşleme Amacı / Hukuki Sebep
                    </span>
                  </template>
                  <ProcessDatasourceDatasubjectProcessingLegalView v-if="activeTab == 6" />
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <span>
                      Aktarım Amacı / Hukuki Sebep
                    </span>
                  </template>
                  <ProcessDatasourceDatasubjectTransferingLegalView v-if="activeTab == 7" />
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <span>
                      Ürün / Varlık Grubu Ana Başlığı
                    </span>
                  </template>
                  <ProductAssetGroupCategoryView v-if="activeTab == 8" />
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <span>
                      Varlık Grubu Ana Başlığı / Varlık Grubu
                    </span>
                  </template>
                  <AssetGroupCategoryAssetGroupView v-if="activeTab == 9" />
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    <span>
                      Risk Tamımı / Uygulanan Kontroller
                    </span>
                  </template>
                  <RiskDefinitionAppliedControlView v-if="activeTab == 10" />
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AssetGroupCategoryAssetGroupView from "./asset-group-category-asset-group-view.vue";
import DatasourceDataView from "./datasource-data-view";
import DepartmentProcessDatasourceView from "./department-process-datasource-datasubject-view.vue";
import DepartmentProcessView from "./department-process-view";
import ProcessDatasourceDatasubjectProcessingLegalView from "./process-datasource-datasubject-processing-legal-view";
import ProcessDatasourceDatasubjectTransferingLegalView from "./process-datasource-datasubject-transfering-legal-view";
import RiskDefinitionAppliedControlView from "./risk-definition-applied-control-view";
import ProcessDatasourceStoragePeriodView from "./process-datasource-storage-period-view";
import ProcessDatasourceView from "./process-datasource-view";
import ProductAssetGroupCategoryView from "./product-asset-group-category-view";
import SectorDepartmentView from "./sector-department-view";

const state = "quickHierarchy";

export default {
  components: {
    AssetGroupCategoryAssetGroupView,
    ProductAssetGroupCategoryView,
    SectorDepartmentView,
    DepartmentProcessView,
    ProcessDatasourceView,
    DatasourceDataView,
    DepartmentProcessDatasourceView,
    ProcessDatasourceStoragePeriodView,
    ProcessDatasourceDatasubjectProcessingLegalView,
    ProcessDatasourceDatasubjectTransferingLegalView,
    RiskDefinitionAppliedControlView,
  },
  data() {
    return {};
  },

  computed: {
    activeTab: {
      get() {
        return this.$store.getters[`${state}/activeTab`];
      },
      set(index) {
        this.$store.commit(`${state}/activeTab`, index);
      },
    },
  },
  methods: {},
};
</script>
